import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { VisitorsGuestsPage } from '@/pages/visitors-dashboard/visitors-guests'

import * as S from './visitors.styled'
import { ClientProfileVisitorsProps } from './visitors.types'

export const Visitors = ({ clientId }: ClientProfileVisitorsProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  const resident = {
    apartment: clientData.apartment,
    buildingNumber: clientData.buildingNumber,
    id: Number(clientId),
    name: `${clientData.user.firstName} ${clientData.user.lastName}`,
  }

  return (
    <S.Container>
      <VisitorsGuestsPage resident={resident} building={clientData.buildingId} />
    </S.Container>
  )
}
